import React from 'react'
import LayoutModal from '../../Layout/Dashboard/LayoutModal'
import FormProjects from './FormProjects'
import { InitialValues, getDataToSend, getInitialValues, getValidationSchema } from './formUtil'
import { usePageState } from '../../lib/state mangment/LayoutPagestate'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useUpdateProjects } from '../../api/projects'

function EditProjectsModal() {
  const {objectToEdit} = usePageState()
  const {status, mutate} = useUpdateProjects();

  const handleSubmit = (value:InitialValues)=>{

    const dataToSend = getDataToSend({...value})

    mutate(dataToSend)
}
  
  return (
    <LayoutModal 
     isAddModal={false}
     getInitialValues={getInitialValues(objectToEdit)} 
     handleSubmit={handleSubmit}
     status={status as QueryStatusEnum}
     headerText='Edit Modal' 
     getValidationSchema={getValidationSchema(objectToEdit)}>
      <FormProjects />
    </LayoutModal>
  )
}

export default EditProjectsModal
